import { RouterProvider } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AuthProvider, useAuth } from './auth/AuthProvider.tsx'
import { ClubGate, useClub } from './club/ClubProvider.tsx'
import { KioskLock } from './kiosk/KioskLock.tsx'
import { AcceptPage } from './pages/Accept.tsx'
import { LoginPage, MfaChallengePage } from './pages/Login.tsx'
import { PrivacyPage } from './pages/Privacy.tsx'
import { router } from './router.tsx'

/** A shared workstation shows the name grid until somebody unlocks it; everything else is the same app. */
function KioskGate({ children }: { children: React.ReactNode }) {
  const { kiosk } = useClub()
  return kiosk && !kiosk.session ? <KioskLock /> : <>{children}</>
}

function Gate() {
  const { t } = useTranslation()
  const { phase } = useAuth()
  // the two one-time links sign somebody (or a workstation) in themselves, so they sit outside the sign-in gate
  if (window.location.pathname === '/accept') return <AcceptPage mode="accept" />
  if (window.location.pathname === '/kiosk/enrol') return <AcceptPage mode="kiosk" />
  if (phase === 'loading') return <main className="grid min-h-dvh place-items-center">{t('common.loading')}</main>
  // the privacy notice is linked from the sign-in page, so it is readable before anybody signs in (M11); signed in, it is a page of the app
  if (window.location.pathname === '/privacy' && (phase === 'signed_out' || phase === 'mfa_required')) return <PrivacyPage standalone />
  if (phase === 'signed_out') return <LoginPage />
  if (phase === 'mfa_required') return <MfaChallengePage />
  return <ClubGate><KioskGate><RouterProvider router={router} /></KioskGate></ClubGate>
}
export default function App() { return <AuthProvider><Gate /></AuthProvider> }
